import { Component } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { CustomerLegalForm } from "../core/model/customer-legal-form";
import { CustomerLegalFormService } from "../core/service/customer-legal-form.service";

@Component({
  selector: "app-legal-form",
  templateUrl: "./legal-form.component.html",
  styleUrls: ["./legal-form.component.scss"],
})
export class LegalFormComponent {
  legalForms: CustomerLegalForm[];

  constructor(
    private _router: Router,
    private _customerLegalFormService: CustomerLegalFormService
  ) {}

  ngOnInit() {
    this.getAllLegalForms();
  }

  getAllLegalForms() {
    this._customerLegalFormService.getAllLegalForms().subscribe(
      (data) => {
        this.legalForms = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  add(): void {
    this._router.navigate(["/parametrage/legal-form/add-legal-form"]);
  }
}
